import React from 'react'
import { COLORS_THEME } from '../../../../constants/colors'
import { IconProps } from '../../../../types/types'

const DealerMasterIcon = ({ size = 24, color = COLORS_THEME.primary }: IconProps) => {
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} xmlns='http://www.w3.org/2000/svg'>
      <g fill={color} fillRule='nonzero'>
        <path
          transform={`scale(${size / 24})`}
          d='M2 18.457V11.68c.02.003.038.007.057.013 3.046 1.034 6.094 2.063 9.136 3.11a2.37 2.37 0 0 0 1.614 0c3.062-1.048 6.128-2.082 9.193-3.123v6.776c-.067.22-.108.454-.205.66-.44.926-1.172 1.38-2.183 1.38L4.388 20.5c-.066 0-.13 0-.195-.003A2.301 2.301 0 0 1 2.086 18.8c-.03-.113-.057-.228-.086-.343z'
        />
        <path
          transform={`scale(${size / 24})`}
          d='M2 10.328V8.096a.334.334 0 0 0 .029-.073c.136-1.03 1.073-2.01 2.419-1.976 1.326.033 2.656.007 3.981.007h.248c0-.335-.01-.637 0-.943.03-.863.719-1.584 1.567-1.598 1.17-.019 2.341-.017 3.512.005.26.013.511.088.737.218.525.297.807.776.833 1.395.012.302 0 .604 0 .923h.268c1.366 0 2.732-.004 4.098 0a2.27 2.27 0 0 1 2.203 1.64c.04.131.071.265.104.4v2.232a.445.445 0 0 1-.052.027c-3.23 1.097-6.46 2.193-9.693 3.285a.883.883 0 0 1-.527-.006c-1.81-.603-3.616-1.222-5.421-1.835-1.436-.488-2.87-.978-4.306-1.47zm8.347-5.118v.829h3.31v-.83h-3.31z'
        />
      </g>
    </svg>
  )
}

export default DealerMasterIcon
